module.exports = __webpack_public_path__ + "img/hacker-headshot.c25f0f22.jpg";